
import {getDistance} from 'geolib';
import {AllRegions, OrderRegion, Region} from 'utils/region';

/**
 * Picks the metro's best ordering region (e.g. new_york) for a visitor
 * who hasn't chosen one: the one whose locations are nearest them, else
 * the one with the most locations (listed first). Metros without one sell
 * national products.
 */
export const pickOrderRegion = (
	region?: Region,
	coords?: {lat: number; lng: number},
): string | undefined => {
	const options = region?.orderRegions ?? [];

	const centered = options.filter((o) => o.center);
	if (coords && centered.length > 1) {
		const distance = (o: OrderRegion) => getDistance(coords, o.center!);
		return centered.reduce((best, o) => (distance(o) < distance(best) ? o : best)).key;
	}

	return options[0]?.key;
};

/**
 * Finds the metro an ordering region is in, so ?region=new_york also
 * selects nyc_metro. If several metros have it (texas), prefer one where
 * it's the main ordering region.
 */
export const findOrderRegionMetro = (key: string): Region | undefined => (
	AllRegions.find((r) => r.orderRegions[0]?.key === key) ??
	AllRegions.find((r) => r.orderRegions.some((o) => o.key === key))
);
